export const customerInputRegExp = /^[a-zA-Z]+$/;
export const invalidTextMsg = 'This field could be only Text';
